import { handleActions } from 'redux-actions';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  userEventsList: [],
  searchResults: [],
  eventDetails: {},
  eventSchedule: {
    jobs: []
  }
};

export default handleActions(
  {
    [actionTypes.GET_EVENTS_SUCCESS]: (state, action) => ({
      ...state,
      userEventsList: action.payload
    }),
    [actionTypes.CREATE_EVENT_SUCCESS]: (state, action) => ({
      ...state,
      userEventsList: [...state.userEventsList, action.payload]
    }),
    [actionTypes.GET_EVENT_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      eventDetails: action.data
    }),
    [actionTypes.GET_EVENT_SCHEDULE_SUCCESS]: (state, action) => ({
      ...state,
      eventSchedule: action.payload
    }),
    [actionTypes.SEARCH_EVENTS_BY_NAME_SUCCESS]: (state, action) => ({
      ...state,
      searchResults: action.data
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/events.js